export const ConstraintTerms = {
  SEG: "seg",
  ATT: "att",
  GEO: "geo",
  ZIP: "zip",
  SDT: "sdt", // @deprecated - use dateFilter (ApiDateFilter)
  EDT: "edt", // @deprecated - use dateFilter (ApiDateFilter)
  DATE_FILTER: "dateFilter", // ApiDateFilter
  ANSWERS: "answers",
  V: "v",
  NAMES: "names",
  OPTIONS: "options",
  ARGS: "args",
  GEOGRAPHY: "geography/",
  QUESTION: "optionQuestionResponse/",
  SEARCH: "search",
} as const;

export type ConstraintTerm = (typeof ConstraintTerms)[keyof typeof ConstraintTerms];
